@if (files) {
  <div>
    <div class="row">
      @for (file of files; track file) {
        <div class="col-4 text-center"><img src="imagens/vl/{{file}}"
        class="img-thumbnail"><br />{{file.split(".")[0]}}</div>
      }
    </div>
    <img src="imagens/volei.jpg" class="img-size">
  </div>
}

<style>
  .img-size {
  display: block;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 90%;
  margin: 20px auto;
}
</style>